/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import newInfiniteScrollMixin from "./mixins/infinite-scroll";
import requester from "modules/requester";

export default baustein.register("user-feed", {
    mixins: [newInfiniteScrollMixin],

    /**
     * This method is called by the infinite-scroll mixin when more content should be loaded.
     * @returns {Promise}
     */
    loadMoreContent(url) {
        return requester(url, {
            headers: {
                Accept: "text/html"
            }
        })
            .then(requester.toText)
            .then(response => {
                const fragment = document.createDocumentFragment();

                const responseWrapper = document.createElement("div");
                responseWrapper.innerHTML = response;

                const userCards = Array.from(responseWrapper.querySelectorAll(".user-card"));
                const nextLinkEl = responseWrapper.querySelector("[data-next-link]");

                userCards.forEach(c => fragment.appendChild(c));

                this.el.querySelector(".user-feed-items").appendChild(fragment);

                return nextLinkEl ? nextLinkEl.getAttribute("data-next-link") : null;
            });
    }
});

